import React from 'react';
import { HomePreview, HomePreviewContent } from '@/components/HomePreview';
import { LoginForm } from '@/components/auth/LoginForm';

const LoginPage = () => {
  console.log('📍 Login page mounted');
  return (
    <div className="min-h-screen flex relative">
      {/* Background preview */}
      <HomePreview>
        <HomePreviewContent />
      </HomePreview>
      
      {/* Login form */}
      <div className="flex items-center justify-center w-full min-h-screen z-10">
        <LoginForm />
      </div>
    </div>
  );
};

export default LoginPage;
